{
  "meta-main-title": " QIC | اشترِ تأمين السفر في دقيقتين🧳",
  "meta-main-desription": "إجازة أو رحلة عمل؟ احم نفسك مع تأمين السفر والعطلات من شركة قطر للتأمين في 4 خطوات: ←🟩 أدخل بياناتك  ←🟩 املأ الاستمارة ←🟩 حمل المستندات ←✅ تم!",
  "quote_discount_online": "تخفيض",
  "quote_proceed": "متابعة",
  "not_found_message_line1": "يبدو أن الصفحة التي تبحث عنها غير",
  "not_found_message_line2": "متاحة",
  "select_country_error": "اختر دولة",
  "from": "من",
  "inbound_from_header": "ما هو  بلد إقامتك؟",
  "inbound_calendar_header": "تواريخ السفر",
  "inbound_calendar_departure": "الانطلاق",
  "inbound_traveling_persons_header": "عدد المسافرين",
  "inbound_travel_insurance_header": "تأمين السفر للقادمين",
  "inbound_calendar_return": "العودة",
  "inbound_nationality_header": "اختر جنسيتك",
  "inbound_nationality_nationality": "الجنسية",
  "inbound_id_header": "أدخل رقم جواز سفرك",
  "inbound_id_number": "رقم جواز السفر",
  "inbound_dob_date": "تاريخ الميلاد",
  "inbound_travelers_check_header": "المسافرون المؤمن عليهم",
  "inbound_travelers_check_passport": "رقم جواز السفر",
  "inbound_travelers_select_nationality": "الجنسية",
  "inbound_travelers_select_relationship": "العلاقة",
  "inbound_travelers_edit_save_button": "حفظ",
  "inbound_travelers_delete_header": "هل تريد مسح معلومات المسافر؟",
  "inbound_travelers_delete_cancel_button": "إلغاء",
  "inbound_travelers_delete_accept_button": "نعم ، امسح",
  "inbound_travelers_add_relationship": "العلاقة",
  "inbound_travelers_add_first_name": "الإسم الشخصي",
  "inbound_travelers_add_last_name": "الإسم العائلي",
  "inbound_travelers_add_qatar_id": "رقم البطاقة القطرية",
  "inbound_travelers_add_dob": "تاريخ الميلاد",
  "inbound_travelers_add_nationality": "الجنسية",
  "inbound_travelers_add_passport": "رقم جواز السفر",
  "inbound_travelers_add_email": "البريد الإلكتروني",
  "inbound_travelers_add_mobile_number": "رقم الجوال",
  "inbound_quote_inclusive_covers": "التغطيات المشمولة",
  "outbound_destinations_disc_us": "قم باختيار </b>رحلات سنوية<b> إذا كنت تخطط للسفر لأكثر من 60 يوم",
  "outbound_destinations_disc_world": "قم باختيار </b>رحلات سنوية<b> إذا كنت تخطط للسفر إلى الولايات المتحدة أو كندا لأكثر من 60 يوم",
  "outbound_destinations_disc_default": "قم باختيار </b>رحلات سنوية<b> إذا كنت تخطط للسفر لأكثر من 90 يوم",
  "outbound_destinations_header": "إلى أين ستسافر؟",
  "outbound_destinations_label": "بلد الوجهة",
  "outbound_destinations_subtitle": "يمكنك إضافة وجهات متعددة",
  "outbound_travel_type_header": "تواريخ السفر",
  "outbound_travel_type_header_multi": "تاريخ بداية الوثيقة",
  "outbound_travel_type_multi": "رحلات متعددة",
  "outbound_travel_type_single": "رحلة واحدة",
  "outbound_travel_type_multi_desc": "خلال السنة",
  "outbound_travel_type_single_desc": "تصل إلى 90 يوما",
  "outbound_calendar_header": "تواريخ السفر",
  "outbound_calendar_single_departure": "الانطلاق",
  "outbound_calendar_single_return": "العودة",
  "outbound_calendar_annual_date": "تاريخ بداية تغطية التأمين",
  "outbound_nationality_header": "الجنسية",
  "outbound_nationality_nationality": "الجنسية",
  "outbound_dob_date": "تاريخ الميلاد",
  "outbound_sport_cover_winter_name": "الرياضات الشتوية",
  "outbound_sport_cover_winter_cover_separately": "إختر التغطيات لكل مسافر على حدة",
  "outbound_sport_cover_winter_description": "التغطية الطبية في حالة تعرضك لحادث أثناء التزلج على الثلج",
  "outbound_sport_cover_winter_description_new": "تغطية طبية إذا تعرضت لإصابة أثناء التزلج أو التزحلق على الجليد. يشمل حد التأمين تغطية الرعاية الطبية الطارئة بقيمة 1,000,000 دولار أمريكي",
  "outbound_travelers_check_header": "المسافرون المؤمن عليهم",
  "outbound_travelers_check_add_button": "أضف شخص آخر",
  "outbound_covid_cover_name": "تغطية كوفيد-19",
  "outbound_covid_cover_description": "تغطية رسوم الخدمات الطبية والاستشفاء والحجر الصحي وإلغاء الرحلة في حالة الإصابة بكوفيد-19",
  "outbound_covid_cover_description_new": "تغطية رسوم الخدمات الطبية والحجر الصحي وإلغاء الرحلة في حالة الإصابة بفيروس كوفيد-19. تغطية تصل إلى 5,000 دولار أمريكي.",
  "outbound_covid_cover_all": "يغطي جميع المسافرين",
  "outbound_additional_header": "تغطيات إضافية",
  "outbound_plans_header": "إختر نوع التأمين",
  "outbound_plans_destination": "الوجهة",
  "outbound_plans_world_name": "جميع أنحاء العالم",
  "outbound_plans_world_description": "تغطية تأمين كاملة في جميع دول العالم",
  "outbound_plans_europe_name": "أوروبا",
  "outbound_plans_europe_description": "متطلب تأمين أساسي للحصول على تأشيرة دول شنغن",
  "outbound_plans_nna_name": "جميع أنحاء العالم باستثناء أمريكا وكندا",
  "outbound_plans_regional_name": "دول المنطقة",
  "outbound_plans_regional_description": "تغطية تأمين تشمل دول مجلس التعاون الخليجي وكل الدول العربية والهند وباكستان وسريلانكا وبنغلاديش وكوريا والفلبين وإندونيسيا ونيبال وبوتان",
  "outbound_plans_ramadan_name": "جميع أنحاء العالم",
  "outbound_plans_ramadan_description": "تغطية تأمين كاملة في جميع دول العالم",
  "outbound_plans_footertext": "قد يتغير السعر النهائي بتغير عدد الأشخاص المؤمنين",
  "outbound_plan_recommended": "نوصي بهذا الخيار",
  "outbound_plan_select_button": "اختر التأمين بقيمة {planPrice}",
  "outbound_quote_regional_name": "دول المنطقة",
  "qic_quote_destination": "الوجهة",
  "travellers_add_first": "إضافة أول شخص",
  "travellers_add_person": "إضافة شخص",
  "travellers_update_info": "تحديث المعلومات",
  "travellers_insured": "المؤمن عليهم",
  "travellers_passport": "رقم جواز السفر",
  "travellers_disclaimer": "تأكد من كتابة بريد إلكتروني صحيح (سيتم إرسال وثيقة التأمين الخاصة بك إلى البريد الإلكتروني الذي تدخله)",
  "home_header1": "تأمين السفر",
  "home_header_desc": "نفتخر بثقة أكثر من 200,000 عميل في قطر",
  "home_feedback_header1": "نفتخر بثقة أكثر من 200,000",
  "home_feedback_header2": "مسافر في قطر",
  "home_form_enter_departure": "إختر وجهتك",
  "home_form_check_your_price": "إظهار السعر",
  "home_includes_medical_header": "النفقات الطبية",
  "home_includes_medical_desc": "العلاج والاستشفاء في حالة المرض أثناء السفر",
  "home_includes_covid_header": "تغطية كوفيد-19",
  "home_includes_covid_desc1": "تغطية رسوم الخدمات الطبية",
  "home_includes_covid_desc2": "والاستشفاء والحجر الصحي",
  "home_includes_covid_desc3": "وإلغاء الرحلة في حالة",
  "home_includes_covid_desc4": "الإصابة بكوفيد-19",
  "home_includes_personal_header": "الحوادث الشخصية",
  "home_includes_personal_desc1": "الحوادث التي تحدث",
  "home_includes_personal_desc2": "أثناء رحلتك، بما في ذلك",
  "home_includes_personal_desc3": "الإصابات والعجز والوفاة",
  "home_includes_belonging_header": "فقدان المتعلقات",
  "home_includes_belonging_desc1": "متعلقاتك الثمينة خلال السفر",
  "home_includes_belonging_desc2": "التعويض في حال فقدان",
  "home_includes_baggage_header": "فقدان الأمتعة",
  "home_includes_baggage_desc": " التعويض عن الأمتعة المفقودة في المطارات أو مناطق الترانزيت",
  "home_includes_tpd_header": "الضرر ضد الغير",
  "home_includes_tpd_desc": "تغطية الخسائر التي قد تسببها أنت لشخص آخر",
  "home_includes_winter_header": "تغطية الرياضات الشتوية",
  "home_includes_winter_desc": "التغطية الصحية في حالة تعرضك لحادث أثناء التزلج على الثلج",
  "home_includes_trip_header": " إلغاء الرحلة",
  "home_includes_trip_desc1": "تغطية المصاريف",
  "home_includes_trip_desc2": "غير القابلة للاسترداد",
  "home_includes_trip_desc3": "في حالة إلغاء رحلتك",
  "home_includes_passport_header": "فقدان جواز السفر",
  "home_includes_passport_desc1": "تغطية تكاليف الحصول",
  "home_includes_passport_desc2": "على وثيقة سفر بديلة",
  "home_includes_legal_header": "النفقات القانونية",
  "home_includes_legal_desc1": "الرسوم القانونية التي قد يتعين",
  "home_includes_legal_desc2": "عليك دفعها أثناء تواجدك بالخارج",
  "home_includes_terrorism_header": "الهجمات الإرهابية",
  "home_includes_terrorism_desc1": "الأضرار والإصابات الناجمة عن الأعمال الإرهابية",
  "home_includes_terrorism_desc2": "في الخارج",
  "home_includes_header": "يشمل تأمين السفر",
  "home_faq_item1_header": "هل أحتاج إلى تصوير أي أوراق وتقديمها بعد الحصول على تأمين السفر رقميا؟",
  "home_faq_item1_content": "لا. شركة قطر للتأمين هي شركة تأمين رقمية، وشراء تأمين السفر على موقعنا الإلكتروني عبارة عملية رقمية بالكامل وفورية وبدون متطلبات ورقية.",
  "home_faq_item2_header": "ما هي مدة صلاحية وثيقة تأمين السفر الخاصة بي؟",
  "home_faq_item2_content": "تتراوح فترة سريان تغطية تأمين السفر من أسبوع واحد (1) إلى ثلاثة أشهر (3 أشهر). التغطية السنوية المتعددة صالحة لمدة عام واحد موزعة على 90 يوم كحد أقصى في كل رحلة.",
  "home_faq_item3_header": "هل يمكن للأشخاص الذين تزيد أعمارهم عن 70 عاما الحصول على وثيقة تأمين السفر؟",
  "home_faq_item3_content": "نعم يمكن تغطية كبار السن، والمتقاعدين الذين تزيد أعمارهم عن 70 عاما من خلال وثيقة تأمين السفر بشرط تقديم شهادة طبية تفيد بأنهم في حالة صحية جيدة قبل بدء رحلتهم. على هذه الفئة من المسافرين مراجعة فروعنا للتأكد من أهليتهم للحصول على التأمين.",
  "home_faq_item4_header": "هل يمكنني الحصول على تأمين سفر لجميع دول العالم؟",
  "home_faq_item4_content": "تغطي وثيقة تأمين السفر الخاصة بك رحلاتك إلى جميع دول العالم، باستثناء الرحلات إلى كل من كوريا الشمالية، وإيران، وفنزويلا. يمكنك الاطلاع على قائمة الدول التي يغطيها تأمين السفر لشركة قطر للتأمين هنا.",
  "home_faq_item5_header": "هل يغطي تأمين السفر من شركة قطر للتأمين متطلبات تأمين تأشيرة شنغن؟",
  "home_faq_item5_content": "نعم. يوفر تأمين السفر من شركة قطر للتأمين تغطية طبية تتراوح بين 50،000 دولار أمريكي و 1،000،000 دولار أمريكي، مما يجعلها مناسبة تماما لمتطلبات ملف تأشيرة الدول الأعضاء في منطقة شنغن.",
  "home_faq_item6_header": "هل يمكن أن يغطي تأمين السفر الخاص بي رحلة الذهاب فقط؟",
  "home_faq_item6_content": "يوفر تأمين السفر من شركة قطر للتأمين تغطية لرحلات الذهاب والعودة معا.",
  "home_faq_item7_header": "هل تقدم شركة قطر للتأمين تأمين السفر للمسافرين إلى قطر أيضا؟",
  "home_faq_item7_content": "نعم. تقدم شركة قطر للتأمين تأمين السفر لكل من المسافرين من قطر الذين يرغبون في الذهاب إلى الخارج، والزوار القادمين إلى قطر من دول أخرى.",
  "home_faq_item8_header": "هل تقدم شركة قطر للتأمين تأمين السفر لرحلات الشركات ورحلات الأعمال؟",
  "home_faq_item8_content": "نعم. تقدم QIC تأمين السفر للأعمال، ورحلات الشركات، والسياحة، ورحلات التطوع، والرحلات الخاصة بالأسرة، والتدريب، فضلا عن الرحلات الدراسية من أسبوع إلى ثلاثة أشهر. التغطية السنوية المتعددة صالحة لمدة عام واحد بما في ذلك 90 يوم كحد أقصى لكل رحلة.",
  "home_faq_item9_header": "هل توجد قائمة أسعار تقديرية لأقساط تأمين السفر؟",
  "home_faq_item9_content": "لا. يتم احتساب قسط التأمين الخاص بك بشكل فردي بناء على مجموعة متنوعة من العوامل، بما في ذلك وجهتك ومدة إقامتك وعمرك والتغطية التي تحتاجها. يمكنك إختيار تأمين سفر رخيص وبسعر مناسب أو اختيار تأمين أشمل مع تغطيات إضافية.",
  "home_faq_item10_header": "هل تقدم شركة قطر للتأمين أي خصومات أو عروض ترويجية على وثائق تأمين السفر للأطفال والعائلات التي لديها أطفال؟",
  "home_faq_item10_content": "نعم. تقدم شركة قطر للتأمين للأطفال والشباب الذين تقل أعمارهم عن 18 عاما خصما بنسبة ٪50 على قسط تأمين السفر.",
  "home_faq_item11_header": "هل يغطي تأمين السفر الخاص بي حقيبة أجهزتي الإلكترونية؟",
  "home_faq_item11_content": "نعم. يغطي تأمين السفر الخاص بك من شركة قطر للتأمين المعدات الإلكترونية التي تحملها معك عند الانطلاق، بما في ذلك أجهزة الكمبيوتر المحمولة، والكاميرات، والأدوات الرقمية الأخرى.",
  "home_faq_item12_header": "هل يغطي تأمين السفر الخاص بي العلاجات الطبية للأمراض الموجودة مسبقا؟",
  "home_faq_item12_content": "يتم استثناء جميع العلاجات الطبية للأمراض الموجودة مسبقا من نطاق وثيقة تأمين السفر الخاصة بك، بما في ذلك الحالات الطبية والأمراض المزمنة، مثل مرضى السكري، وفيروس نقص المناعة، وارتفاع الكوليسترول، والاضطرابات العقلية، واضطرابات الحمل، والقلق، والاكتئاب.",
  "home_faq_item13_header": "هل يغطي تأمين السفر الخاص بي ممارسة رياضات المغامرات؟",
  "home_faq_item13_content": "إذا كنت مسافرا عالي المخاطر فيجب أن تعلم أن المشاركة في أي رياضات مغامرات مثل الغوص، والرياضات المائية بما في ذلك التزلج على الماء، وسباقات الدراجات النارية، والتسلق وما إلى ذلك غير مشمولة بالتأمين العادي على السفر. ومع ذلك، يمكن ترقية وثيقتك للحصول على قسط إضافي ليشمل ملحق تغطية الرياضات الشتوية الذي يغطي التزلج الترفيهي والتزلج على الجليد.",
  "home_faq_item14_header": "هل يمكن أن يغطي تأمين السفر الخاص بي الحيوانات الأليفة التي تسافر معي؟",
  "home_faq_item14_content": "الحيوانات الأليفة بشكل عام، بما في ذلك القطط والكلاب، ليست مشمولة في وثيقة تأمين السفر الأساسية الخاصة بك.",
  "home_faq_item15_header": "هل يغطي تأمين السفر السيارات والمركبات والدراجات النارية التي سأستأجرها أثناء وجودي في الخارج؟",
  "home_faq_item15_content": "لا يغطي تأمين السفر الخاص بك من شركة قطر للتأمين أي مركبات تستأجرها في البلد الذي تقصده، بما في ذلك السيارات والدراجات النارية أو أي مركبات أخرى قد تستأجرها أو تشتريها أثناء إقامتك في الخارج.",
  "home_faq_item16_header": "هل يغطيني تأمين السفر الخاص بي في حالة الكوارث الطبيعية (إعصار، بركان..الخ)؟",
  "home_faq_item16_content": "لا يغطي تأمين السفر الخسائر أو الأضرار الناتجة عن الكوارث الطبيعية ، مثل الزلازل أو الأنشطة البركانية أو الفيضانات أو العواصف، بالإضافة إلى الكوارث الأخرى، مثل الحروب، والاضطرابات المدنية، والإضرابات وغيرها من الأحداث المتعلقة بالقدر.",
  "home_faq_item17_header": "ما الذي تشمله تغطية تأمين السفر الخاصة بكوفيد-19؟",
  "home_faq_item17_content": "في حالة الإصابة المؤكدة بكوفيد-19 أثناء رحلتك، ستغطي وثيقة تأمينك الشاملة تغطية كوفيد-19 تكلفة الاستشفاء الإجباري المعتمد، والحجر الصحي الإجباري في فندق معتمد من الحكومة، فضلا عن العلاجات الطبية من المرض.",
  "home_faq_item18_header": "هل يغطي تأمين السفر الخاص بكوفيد-19 الحجر الصحي في المنزل والعزل الذاتي؟",
  "home_faq_item18_content": "لا يغطي تأمين السفر الخاص بكوفيد-19 نفقات الحجر المنزلي والعزل الذاتي.",
  "home_faq_item19_header": "هل تقدمون تغطية تأمين السفر الخاصة بكوفيد-19 للأشخاص غير المطعمين؟",
  "home_faq_item19_content": "نعم. تقدم QIC تغطية كوفيد-19 للأشخاص الذين تم تطعيمهم، ولغير المطعمين، والمتعافين، والأشخاص الذين لم يصابوا قبل بكوفيد-19.",
  "home_faq_item20_header": "كيف يمكنني تقديم مطالبة؟",
  "home_faq_item20_content": "يمكنك تقديم مطالبتك على الفور عبر موقعنا الإلكتروني، أو عن طريق واتساب على  0742 5000، أو الاتصال بالرقمين 97143823700+ / 97143178500+ وإرسال نموذج المطالبة، ورقم وثيقة تأمين السفر، والمستندات الأخرى المتعلقة بمطالبتك، مثل الإيصالات، والتقارير الطبية، وتقارير الشرطة أو غيرها من التقارير عند الاقتضاء.",
  "home_faq_item21_header": "متى يمكنني تقديم مطالبة؟",
  "home_faq_item21_content": "يمكنك تقديم المطالبات على مدار الساعة وطوال أيام الأسبوع. يجب الإبلاغ عن فقدان الأمتعة أو تلفها أثناء الترانزيت، وفقدان جواز السفر، وإلغاء الرحلة على الفور. يجب تقديم مطالبات المصاريف الطبية في غضون 48 ساعة من دخول المستشفى للعلاج خارج قطر.",
  "home_faq_item22_header": "ما هي رسوم الوثيقة الإضافية؟",
  "home_faq_item22_content": "رسوم الوثيقة الإضافية (أو مبلغ الاقتطاع) هو المبلغ الثابت من المال الذي يتعين عليك دفعه عند كل مطالبة. إن الغاية من فرض رسوم الوثيقة الإضافية هي تخفيض القيمة الإجمالية لقسط تأمين السفر.",
  "home_faq_item23_header": "أين توجد فروع شركة قطر للتأمين؟",
  "home_faq_item23_content": "يوجد مكتبنا الرئيسي في الخليج الغربي والفروع الأخرى في فيلاجيو مول، ولاندمارك مول، وسيتي سنتر مول، وشارع بروة التجاري، وإزدان مول في الوكرة، ولولو هايبر ماركت في الغرافة، ولولو المسيلة، والخور، والمنصورة.",
  "home_faq_item24_header": "ما هي معلومات الاتصال بكم من أجل الاستفسارات العامة المتعلقة بتأمين السفر؟",
  "home_faq_item24_content": "يمكنك الاتصال بالخط الساخن لشركة قطر للتأمين على الرقم 8000 742 أو عبر الواتس اب على 5000 0742 لجميع الاستفسارات المتعلقة بالتأمين على السفر.",
  "home_faq_item25_header": "ما الذي يغطيه تأمين السفر؟",
  "home_faq_item25_content": "إن تأمين السفر هو خيارك الأساسي من أجل ضمان راحة البال خلال فترة وجودك في الخارج، سواء تعلق الأمر بالسفر بمفردك، مع عائلتك، أو مع الأصدقاء. يمكن أن يعوضك تأمين السفر إذا اضطررت إلى إلغاء رحلتك فجأة، أو إذا فقدت أمتعتك أو واجهت مشاكل صحية غير متوقعة أثناء سفرك للخارج سواء كانت عطلة عائلية أو في رحلة عمل.",
  "home_form_travelling_abroad": "السفر للخارج",
  "home_form_visiting_qatar": "زيارة قطر",
  "home_form_outbound_destinations_label": "بلد الوجهة",
  "home_form_inbound_destination_label": "بلد الإقامة",
  "home_feedback_holder_text1": "«أفضل حلول تأمين السفر الرقمية في قطر. لقد أصبح التأمين سهلا، بكل معنى الكلمة»",
  "home_feedback_holder_author1": "جاستن هوتان",
  "home_feedback_holder_author_desc1": "سافر إلى قطر لمدة ستة أشهر",
  "home_feedback_holder_text2": "«فريق رائع وخدمة ممتازة! شكرا لكم يا قطر للتأمين»",
  "home_feedback_holder_author2": "راشد المحمود",
  "home_feedback_holder_author_desc2": "سافر للمرة الأولى مع QIC",
  "home_feedback_holder_text3": "«خدمات احترافية وفريق عمل ودود وأسعار مناسبة للغاية».",
  "home_feedback_holder_author3": "سمير خان",
  "home_feedback_holder_author_desc3": "زار جميع الدول الأوروبية",
  "home_feedback_holder_text4": "«حصلت على تأمين السفر بسعر جيد مع تغطية كوفيد-19، واستغرق الأمر بضع دقائق فقط. تجربة أوصي بها للجميع»",
  "home_feedback_holder_author4": "ديلوم جاياناث",
  "home_feedback_holder_author_desc4": "زار 4 دول",
  "quote_info_audlts": "راشدين",
  "quote_info_children": "أطفال",
  "quote_info_outbound_title": "تأمين السفر للخارج",
  "quote_info_inbound_title": "تأمين السفر للقادمين",
  "quote_info_inbound_to_qatar": "تأمين السفر للقادمين",
  "quote_country_residence": "بلد الإقامة",
  "qar": "ر.ق‎",
  "qic_covered": "يغطي",
  "landing_award": {
    "title": "لماذا قطر للتأمين؟",
    "award_title": "أفضل شركة تأمين سفر في الشرق الأوسط 2024",
    "award_description": "جوائز جلوبال بانكينج أند فاينانس ريفيو",
    "rating": "لدينا تصنيفات جيدة من أهم وكالات التصنيف الائتماني"
  },
  "travel_logo": {
    "item1": "تأمين",
    "item2": "السفر"
  },
  "outbound": {
    "personal_information": {
      "header": "البيانات الشخصية"
    },
    "travelers": {
      "first_name": "الإسم الشخصي",
      "last_name": "الإسم العائلي",
      "qatar_id": "رقم البطاقة القطرية",
      "email": "البريد الإلكتروني",
      "gender": {
        "male": "ذكر",
        "female": "أنثى",
        "label": "ملصق"
      }
    },
    "contacts": {
      "title": "بيانات التواصل"
    },
    "traveling_persons": {
      "adults": {
        "label": "راشدين",
        "annotation": "18 إلى 70 سنة"
      },
      "children": {
        "label": "أطفال",
        "annotation": "0 إلى 17 سنة"
      },
      "annotation": {
        "text": "التأمين عبر الإنترنت متاح للمسافرين الذين تقل أعمارهم عن <strong>70 سنة</strong>. لتأمين شخص أكبر سنا،",
        "text_new": "التأمين عبر الإنترنت متاح للمسافرين الذين تقل أعمارهم عن 70 سنة. لتأمين شخص أكبر سنا،",
        "link": "تواصل معنا"
      }
    },
    "destinations": {
      "change": {
        "label": "بلد الوجهة",
        "placeholder": "بلد الوجهة",
        "done_button": "تم"
      }
    },
    "plans": {
      "policy_information": {
        "header": "بيانات التأمين",
        "travellers": "المسافرون",
        "period": "مدة التأمين",
        "people": "شخص|شخص واحد|شخصان {personCount}|أشخاص {personCount}|شخص {personCount}|أشخاص {personCount}",
        "destination": "الوجهة"
      },
      "plan_information": {
        "addon_badge": "تغطية إضافية",
        "policy_wording": "نص الوثيقة",
        "addon_price_annotation": "السعر لا يتضمن التغطيات الإضافية",
        "addon_quote_text": "يمكنك إضافة هذه التغطية للمسافرين الذين يحتاجونها في صفحة عرض الأسعار النهائية",
        "addon_price_text": "{price} ر.ق للشخص الواحد"
      }
    },
    "calendar": {
      "trip_length": "يمكن أن تصل مدة كل رحلة إلى 90 يوم",
      "trip_length_60": "يمكن أن تصل مدة كل رحلة إلى 60 يوم",
      "first_departure": "تاريخ الوصول"
    },
    "travelling_persons": {
      "annotation": "Online insurance is available for travelers under <strong>70 years</strong>. If you need to insure someone older, please contact us to continue"
    },
    "plan": {
      "wordldwide_ex": {
        "name": "جميع أنحاء العالم باستثناء أمريكا وكندا"
      },
      "fly_europe": {
        "name": "أوروبا"
      },
      "worldwide": {
        "name": "جميع أنحاء العالم"
      },
      "regional": {
        "name": "دول المنطقة"
      },
      "worldwide_limited": {
        "name": "العالمية المحدودة"
      },
      "europe": {
        "name": "أوروبا"
      }
    },
    "cyber_security_addon": {
      "name": "التغطية السيبرانية",
      "desc": "حماية من عمليات الاحتيال في الشراء عبر الإنترنت، وسرقة الهوية وسرقة الأموال والتصيد الاحتيالي وغيرها من التهديدات الإلكترونية. تغطية تصل إلى 5,000 دولار أمريكي.",
      "desc_1": "تحمي صاحب الوثيقة بتغطية",
      "desc_2": "تصل إلى 5000 دولار أمريكي",
      "desc_3": "ضد عمليات الاحتيال أثناء الشراء عبر الإنترنت، وانتحال الشخصية، وسرقة الأموال، والتصيد الاحتيالي، وغيرها من التهديدات الإلكترونية الأخرى"
    },
    "select_plan": {
      "header": "خصص وثيقة تأمينك",
      "policy_info": {
        "number_of_travellers": "عدد المسافرين"
      },
      "included_header": "التأمين يشمل",
      "coverage": {
        "label": "التغطية",
        "worldwide": "جميع أنحاء العالم",
        "worldwide_excl": "باستثناء أمريكا وكندا",
        "worldwide_desc": "لا تغطي الوثيقة السفر إلى إيران، كوريا الشمالية، وفنزويلا",
        "regional": "الدول العربية والخليج، وشبه القارة الهندية، وجنوب شرق آسيا",
        "regional_desc": "تغطي الوثيقة دول الخليج، والدول العربية، والهند، وسريلانكا، وبنغلاديش، وكوريا الجنوبية، والفلبين، وإندونيسيا، ونيبال، وبوتان",
        "fly_europe": "منطقة الشنغن",
        "fly_europe_desc": "جميع دول شنغن"
      },
      "coverage_limit": {
        "label": "حدود التغطية",
        "europe_limit": "50,000 دولار أمريكي",
        "non_europe_limit": "1,000,000 دولار أمريكي",
        "worldwide_desc": "الحد الأقصى للتغطية للعلاج الطبي في الخارج",
        "regional_europe_desc": "الحد الأقصى للتغطية للعلاج الطبي في البلدان المغطاة"
      },
      "addon_annotation": "قد يتغير السعر النهائي حسب عدد الأشخاص المؤمنين. السعر لا يتضمن التغطيات الإضافية",
      "select_button": "احصل عليه مقابل {number}",
      "extra_benefits": {
        "title": "مزايا إضافية",
        "extended_coverage": "تغطية موسعة",
        "increased_limit": "حدود التغطية الجديد",
        "increased_limit_desc": "الحد الأقصى للتغطية للعلاج الطبي في الخارج"
      },
      "extended_coverage": {
        "desc": "لا تغطي الوثيقة السفر إلى إيران، كوريا الشمالية، وفنزويلا"
      },
      "one_year_policy": {
        "title": "أريد تأمين لمدة سنة واحدة",
        "trips": "رحلات دولية غير محدودة",
        "trip_days": "30/60/90 يوم أو أكثر",
        "long_term": "إقامة طويلة الأمد"
      },
      "insurance_values": {
        "header_two_plans": "اختر خطة تأمينك",
        "header_one_plan": "خطة تأمينك",
        "travelers": "{travelersCount} مسافر|{travelersCount} مسافر واحد|{travelersCount} مسافران|{travelersCount} مسافرون|{travelersCount} مسافراً|{travelersCount} مسافراً",
        "discount": "خصم {discount}%",
        "category_1": {
          "label": "التأمين الصحي",
          "item_1": {
            "name": " الرعاية الطبية الطارئة",
            "desc": "1,000,000 دولار أمريكي",
            "tooltip_desc": "الرعاية الطارئة، والإخلاء الطبي، ورعاية المواليد الجدد، ودخول الطفل إلى المستشفى، والإعادة إلى الوطن، والمساعدة الطبية على مدار الساعة",
            "desc_flyeurope": "50,000 دولار أمريكي",
            "pop_desc_1_1": "الرعاية الطبية الطارئة في المستشفى. ",
            "pop_desc_1_2": "العلاج والإقامة داخل المستشفى، والعمليات الجراحية، والأدوية",
            "pop_desc_2_1": "الإخلاء الطبي. ",
            "pop_desc_2_2": "النقل إلى أقرب مستشفى أو العودة إلى الوطن في حالة المرض الشديد",
            "pop_desc_3_1": "رعاية الولادة المبكرة. ",
            "pop_desc_3_2": "تغطية تكاليف الرعاية الطبية للمواليد الجدد في حالة الولادة المبكرة قبل 32 أسبوعاً",
            "pop_desc_4_1": "دخول الطفل إلى المستشفى. ",
            "pop_desc_4_2": "تغطية إقامة الوالدين أو الوصي عند دخول الطفل للمستشفى إذا كان أقل من 12 عاماً",
            "pop_desc_5_1": "مساعدة طبية على مدار الساعة. ",
            "pop_desc_5_2": "تغطية أي خدمات مساعدة عند تعرض الشخص المؤمن عليه لحالة طبية طارئة أثناء الرحلة",
            "pop_desc": "رعاية طارئة للأسنان لتسكين الألم، تشمل الحشوات الأساسية والإصلاحات"
          },
          "item_2": {
            "name": "علاج الأسنان الطارئ",
            "desc": "250 دولار أمريكي لكل مطالبة"
          },
          "item_3": {
            "name": "الرياضات الشتوية",
            "pop_desc": "حوادث التزلج على الجليد"
          },
          "item_4": {
            "name": "كوفيد-19",
            "pop_desc": "العلاج والحجر الصحي وانقطاع الرحلة",
            "pop_desc_reg": "العلاج والحجر الصحي وانقطاع الرحلات. متاح فقط في الخطة العالمية"
          },
          "item_2_1": {
            "name": "البحث والإنقاذ",
            "desc": "10,000 دولار أمريكي",
            "pop_desc": "في حال فقدان الشخص أو إصابته في مناطق نائية مثل الجبال أو البحار وغيرها."
          },
          "item_2_2": {
            "name": "حوادث السفر",
            "desc": "50,000 دولار أمريكي",
            "pop_desc": "الوفاة أو فقدان الأطراف أو العجز الدائم بسبب حادث سفر"
          },
          "quote_desc": "الرعاية الطارئة، والإخلاء الطبي، ورعاية المواليد الجدد، وعلاج الأطفال في المستشفيات، والإعادة إلى الوطن، والمساعدة الطبية على مدار الساعة"
        },
        "category_2": {
          "label": "المتعلقات",
          "item_1": {
            "name": "فقدان الأمتعة أو تلفها",
            "desc": "5,000 دولار أمريكي",
            "pop_desc": "سرقة الأمتعة أو تلفها أثناء السفر نتيجة لجريمة أو حريق أو حادث"
          },
          "item_2": {
            "name": "فقدان جواز السفر",
            "desc": "250 دولار أمريكي",
            "pop_desc": "تغطية تكاليف الاستبدال والنفقات المتعلقة بالسفر والفنادق في حال فقدان أو سرقة جواز السفر"
          },
          "item_3": {
            "name": "المعدات الرياضية",
            "desc": "1,000 دولار أمريكي",
            "pop_desc": "تغطية المعدات الرياضية المفقودة أو التالفة (مثل مضرب التنس، الزلاجات، لوح التزلج على الأمواج)"
          },
          "item_1_1": {
            "name": "تأخّر الأمتعة",
            "desc": "500 دولار أمريكي",
            "pop_desc": "أموال لتغطية الاحتياجات الأساسية أثناء انتظار وصول الأمتعة المتأخرة"
          },
          "item_3_1": {
            "name": "المعدات الرياضية المستأجرة",
            "desc": "500 دولار أمريكي",
            "pop_desc": "تغطية تكاليف الإيجار في حال فقدان أو تلف المعدات"
          },
          "quote_desc": "فقدان الأمتعة أو تلفها أو تأخرها أو فقدان جواز السفر أو فقدان أو تلف المعدات الرياضية"
        },
        "category_3": {
          "label": "السفر",
          "item_1": {
            "name": "إلغاء أو تأجيل الرحلات",
            "desc": "5,000 دولار أمريكي"
          },
          "item_2": {
            "name": "المسؤولية الشخصية",
            "desc": "1,000,000 دولار أمريكي",
            "pop_desc": "تغطية الرسوم القانونية إذا تم مقاضاتك بسبب إصابة عرضية أو تلف ممتلكات في الخارج"
          },
          "item_3": {
            "name": "المساعدة القانونية في الخارج",
            "desc": "25,000 دولار أمريكي",
            "pop_desc": "تغطية تكاليف القضايا القانونية المتعلقة بإصابة أو مرض تسبب به آخرون خارج البلاد"
          },
          "item_4": {
            "name": "العودة غير المخطط لها",
            "desc": "2,500 دولار أمريكي",
            "pop_desc": "تغطية تكاليف العودة الطارئة بسبب مرض خطير، أو إصابة، أو أي أحداث أخرى مشمولة ضمن التأمين"
          },
          "item_1_1": {
            "name": "إلغاء الرحلات",
            "desc": "5,000 دولار أمريكي",
            "pop_desc": "تغطية تكاليف الرحلة غير القابلة للاسترداد عند الإلغاء نتيجة المرض، الوفاة، فقدان الوظيفة، الحمل، وما إلى ذلك"
          },
          "item_1_2": {
            "name": "تأخير الرحلات",
            "desc": "5,000 دولار أمريكي",
            "pop_desc": "تغطية الإقامة والوجبات إذا تأخرت رحلتك لأكثر من ساعتين بسبب ظروف غير متوقعة"
          },
          "item_4_1": {
            "name": "الاختطاف"
          },
          "item_4_2": {
            "desc": "1,500 دولار أمريكي"
          },
          "item_4_3": {
            "pop_desc": "تعويض يومي قدره 250 دولاراً أمريكياً في حالات اختطاف وسائل النقل"
          },
          "quote_desc": "إلغاء أو تأخير الرحلات، المساعدة القانونية في الخارج، تعويض في حالات الاختطاف، المسؤولية الشخصية"
        },
        "addon": "إضافة",
        "plan_badge": {
          "full_cover": "خطة شاملة",
          "budget": "خطة اقتصادية"
        },
        "plan": {
          "worldwide": {
            "name": "تغطية متكاملة \u2028+ أمريكا وكندا"
          },
          "worldwideexcl": {
            "name": "تغطية متكاملة"
          },
          "regional": {
            "name": "تغطية دول المنطقة"
          },
          "flyeurope": {
            "name": "تغطية أساسية"
          }
        },
        "plan_desc": {
          "common": "تغطي صحتك وأمتعتك ورحلاتك.",
          "excl_all": "لا تشمل الولايات المتحدة الأمريكية وكندا وإيران وكوريا الشمالية وفنزويلا",
          "visa": "صالحة للتأشيرة.",
          "appl_world": "سارية في جميع أنحاء العالم",
          "excl": "باستثناء إيران وكوريا الشمالية وفنزويلا",
          "gcc": "لا تشمل تغطية كوفيد-19. سارية فقط في منطقة الشرق الأوسط وآسيا",
          "schengen": "تغطية صحية فقط. صالحة للتأشيرة. مقتصرة على دول الشنغن"
        },
        "plan_tooltip": {
          "worldwideexcl": "لا تشمل الولايات المتحدة الأمريكية وكندا وإيران وكوريا الشمالية وفنزويلا",
          "regional_1": "دول الخليج: البحرين، والكويت، وعمان، وقطر، والمملكة العربية السعودية، والإمارات العربية المتحدة.",
          "regional_2": "الدول العربية: العراق، والأردن، ولبنان، وفلسطين، وسوريا، واليمن.",
          "regional_3": "شبه القارة الهندية: الهند، وباكستان، وسريلانكا، وبنغلاديش.",
          "regional_4": "جنوب شرق آسيا: كوريا الجنوبية، والفلبين، وإندونيسيا، ونيبال، وبوتان.",
          "worldwide": "لا تشمل إيران، وكوريا الشمالية، وفنزويلا"
        },
        "plan_price_annotation": "سعر {travellerCount} مسافر دون إضافات| سعر {travellerCount} مسافر واحد دون إضافات| سعر {travellerCount} مسافران دون إضافات| سعر {travellerCount} مسافرون دون إضافات| سعر {travellerCount} مسافر دون إضافات| سعر {travellerCount} مسافر دون إضافات",
        "pop_up": {
          "header": "تفاصيل خطة التأمين",
          "header_upd": "تفاصيل التغطية"
        },
        "common_values": "الممتلكات والرحلات والصحة",
        "addons": {
          "winter_covid": "الإضافات المتاحة: الرياضات الشتوية وكوفيد-19",
          "validity": {
            "all_countries": "صالح في جميع الدول",
            "common_excl": "لا تشمل إيران، وكوريا الشمالية، وفنزويلا",
            "excl_usa": "غير صالح في الولايات المتحدة الأمريكية وكندا",
            "also_common_excl": "لا تشمل إيران، وكوريا الشمالية، وفنزويلا",
            "regional": "صالح فقط في الشرق الأوسط وآسيا",
            "regional_gcc": "دول الخليج: البحرين، الكويت، عمان، قطر، المملكة العربية السعودية، الإمارات العربية المتحدة.",
            "regional_arab": "الدول العربية: العراق، الأردن، لبنان، فلسطين، سوريا، اليمن.",
            "regional_isc": "شبه القارة الهندية: الهند، باكستان، سريلانكا، بنغلاديش.",
            "regional_sea": "جنوب شرق آسيا: كوريا الجنوبية، الفلبين، إندونيسيا، نيبال، بوتان.",
            "valid_excl_usa": "صالح في جميع الدول باستثناء الولايات المتحدة الأمريكية وكندا",
            "europe": "صالح فقط في دول شنغن",
            "europe_countries": "النمسا، بلجيكا، بلغاريا، كرواتيا، جمهورية التشيك، الدنمارك، إستونيا، فنلندا، فرنسا، ألمانيا، اليونان، هنغاريا، أيسلندا، إيطاليا، لاتفيا، ليختنشتاين، ليتوانيا، لوكسمبورغ، مالطا، هولندا، النرويج، بولندا، البرتغال، رومانيا، سلوفاكيا، سلوفينيا، إسبانيا، السويد، سويسرا"
          },
          "covid": "إضافة كوفيد-19 متاحة",
          "not_covid": "إضافة كوفيد-19 غير متاحة"
        },
        "covered": {
          "header": "تفاصيل التأمين",
          "annottation": {
            "ww_wwexcl": "الحماية مشمولة في كل من الخطتين العالمية والعالمية المحدودة.",
            "wwexcl_regional": "الحماية مشمولة في كل من الخطتين العالمية والإقليمية."
          },
          "health": {
            "header": "الصحة",
            "em_medical_care": {
              "label": "الرعاية الطبية الطارئة",
              "amount": "1,000,000 دولار أمريكي",
              "tooltip": "الرعاية الطبية الطارئة في المستشفيات، والإخلاء الطبي، ورعاية الأطفال حديثي الولادة، وإدخال الأطفال إلى المستشفى، والإعادة إلى الوطن، والمساعدة الطبية على مدار الساعة",
              "desc": "النفقات الطبية الطارئة، بما في ذلك علاج الأسنان"
            },
            "em_dental": {
              "label": "علاج الأسنان الطارئ",
              "amount": "250 دولار أمريكي لكل مطالبة"
            },
            "rescue": {
              "label": "البحث والإنقاذ",
              "amount": "10,000 دولار أمريكي"
            },
            "travel_accident": {
              "label": "حوادث السفر",
              "amount": "50,000 دولار أمريكي"
            }
          },
          "trip": {
            "header": "الرحلات",
            "cancellation": {
              "label": "إلغاء الرحلات أو تأجيلها",
              "amount": "5,000 دولار أمريكي"
            },
            "pers_liability": {
              "label": "المسؤولية الشخصية",
              "amount": "1,000,000 دولار أمريكي"
            },
            "legal_help": {
              "label": "المساعدة القانونية في الخارج",
              "amount": "25,000 دولار أمريكي"
            },
            "unsch_return": {
              "label": "العودة غير المخطط لها",
              "amount": "2,500 دولار أمريكي"
            },
            "desc": "إلغاء الرحلات أو تأخيرها، النفقات القانونية، وحوادث السفر الأخرى"
          },
          "belongings": {
            "header": "الممتلكات",
            "bag_loss": {
              "label": "فقدان الأمتعة أو تلفها",
              "amount": "5,000 دولار أمريكي"
            },
            "passport": {
              "label": "فقدان جواز السفر",
              "amount": "250 دولار أمريكي"
            },
            "sports_gear": {
              "label": "المعدات الرياضية",
              "amount": "1,000 دولار أمريكي"
            },
            "desc": "فقدان أو تلف الأمتعة وجواز السفر والمعدات الرياضية"
          },
          "addons": {
            "header": "الإضافات",
            "winter_sports": {
              "label": "الرياضات الشتوية",
              "amount": "1,000,000 دولار أمريكي"
            },
            "covid": {
              "label": "كوفيد-19",
              "amount": "5,000 دولار أمريكي",
              "worldwide_note": "متاح فقط في الخطة العالمية"
            },
            "annotation": "أضف إلى تأمينك في صفحة عرض السعر"
          }
        },
        "medical_care_ww": "ما يصل إلى 1,000,000 دولار أمريكي للرعاية الطبية الطارئة",
        "belongings_incl": "يشمل فقدان الممتلكات أو تلفها",
        "cancellation_incl": "يشمل إلغاء الرحلات أو تأخيرها",
        "medical_care_europe": "ما يصل إلى 50,000 دولار أمريكي للرعاية الطبية الطارئة",
        "belongings_excl": "لا يشمل فقدان الممتلكات أو تلفها",
        "cancellation_excl": "لا يشمل إلغاء الرحلات أو تأخيرها",
        "payout_limit": "حد التعويضات",
        "visa_valid": "صالح للتأشيرة",
        "coverage": "التغطية",
        "ww_coverage": {
          "header": "تغطية عالمية",
          "common_excl": "صالح في جميع الدول باستثناء إيران وكوريا الشمالية وفنزويلا",
          "usa_excl": "صالح في جميع الدول باستثناء الولايات المتحدة الأمريكية وكندا وإيران وكوريا الشمالية وفنزويلا"
        }
      }
    },
    "addon": {
      "learn_more": "المزيد",
      "error": "لم نتمكن من تضمين الإضافة في عرض السعر. يرجى المحاولة مرة أخرى"
    },
    "personal_info": {
      "qid_exp_date": "تاريخ صلاحية البطاقة القطرية"
    }
  },
  "outbound_travelers_add_mobile_number": "رقم الجوال",
  "inbound": {
    "personal_information": {
      "header": "المعلومات الشخصية"
    },
    "contacts": {
      "title": "بيانات التواصل"
    },
    "traveling_persons": {
      "adults": {
        "label": "راشدين",
        "annotation": "18 إلى 65 سنة"
      },
      "children": {
        "label": "أطفال",
        "annotation": "0 إلى 17 سنة"
      },
      "description": {
        "text": "التأمين عبر الإنترنت متاح للمسافرين الذين تقل أعمارهم عن <strong>65 سنة</strong>. لتأمين شخص أكبر سنا،",
        "text_new": "التأمين عبر الإنترنت متاح للمسافرين الذين تقل أعمارهم عن 65 سنة. لتأمين شخص أكبر سنا،",
        "link": "تواصل معنا"
      },
      "count_warning": "يمكن التأمين على <b> 30 مسافر فقط </b> بموجب وثيقة تأمين واحدة",
      "count_warning_new": "يمكن التأمين على 30 مسافر فقط بموجب وثيقة تأمين واحدة",
      "annotation": "Online insurance is available for travelers under <strong>65 years</strong>. If you need to insure someone older, please contact us to continue"
    },
    "view_plan": {
      "policy_wording": "نص الوثيقة"
    },
    "plan": {
      "policy_information": {
        "people": "شخص|شخص واحد|شخصان|أشخاص|شخص|أشخاص",
        "header": "بيانات التأمين",
        "header_new": "تفاصيل التأمين",
        "period": "مدة التأمين",
        "travellers": "المسافرون"
      },
      "inbound": {
        "name": "تأمين السفر للقادمين"
      }
    },
    "travelers": {
      "add_button": "إضافة مسافر"
    },
    "country_of_residence": {
      "mandatory:insurance_wordings": {
        "start": "للدخول إلى قطر يجب أن يكون لديك تأمين صحي إلزامي.",
        "start_new": "لدخول قطر، يجب أن يكون لديك تأمين صحي.",
        "link": "احصل عليه",
        "link_new": "شراء التأمين الصحي والتأمين على الحياة معاً",
        "end": "بشكل مستقل"
      }
    }
  },
  "qic": {
    "error": {
      "fill_field": "املأ الحقل",
      "email": {
        "format": "أدخل بريدا إلكترونيا بتنسيق example{'@'}domain.com"
      },
      "phone": {
        "format": "Invalid format",
        "empty": "املأ الخانة",
        "consist_11_digits": "صيغة غير صالحة"
      },
      "qid": {
        "start_with_2_3": "يجب أن يبدأ بالرقم 2 أو 3",
        "consist_11_digits": "يجب أن يتكون من 11 رقم"
      }
    },
    "common": {
      "insuranceLimit": "حدود التأمين:",
      "learn_more": "اكتشف المزيد"
    },
    "close": "إغلاق"
  },
  "plan": {
    "single_trip": {
      "change_dates": {
        "header": "Change travel dates",
        "save_button": {
          "text": "حفظ"
        }
      }
    },
    "multi_trip": {
      "change_dates": {
        "header": "Change departure date",
        "annotation": "6 months multi-trip from {departureDate} till {endDate}.\u2028\nThe maximum trip length is 90 days"
      }
    }
  },
  "inbound_traveling_persons": {
    "change": {
      "header": "عدد المسافرين",
      "save_button": "حفظ"
    }
  },
  "check_quote": {
    "policy_holder": {
      "contacts": {
        "title": "Contacts"
      },
      "label": "الشخص المؤمن عليه"
    },
    "insured_person": {
      "winter_cover_badge": "Winter Cover"
    },
    "header": "عرض سعرك",
    "travel_dates": "مدة التأمين",
    "full_name": "الإسم الكامل",
    "covid_cover": {
      "risks": {
        "annotation": "لن نغطي أي نفقات تتعلق بكوفيد-19 إذا قمت بإزالة هذه التغطية الإضافية"
      },
      "limit": "5,000 دولار أمريكي"
    },
    "winter_cover": {
      "risks": {
        "annotation": "لن نغطي أي مساعدة طبية في حالة التعرض لحادث أثناء التزلج على الثلج إذا قمت بإزالة هذه التغطية الإضافية"
      },
      "limit": "مشمولة ضمن تغطية الرعاية الطبية الطارئة بمبلغ 1,000,000 دولار أمريكي"
    },
    "person": "لكل شخص",
    "people": "لـ 0 أشخاص | لشخص واحد | لشخصين | لـ {count} أشخاص | لـ {count} شخصاً | لـ {count} أشخاص",
    "airalo": {
      "badge": "عرض مميّز",
      "header": "خصم 20% على باقات الجوّال خارج البلاد",
      "desc": "بعد الشراء، ستحصل على خصم للبقاء على اتصال في جميع أنحاء العالم.",
      "link": "اعرف المزيد"
    },
    "coins_reward": "مكافأة الكوينز",
    "ooredoo": {
      "header": "باقات جوال للمسافرين",
      "desc": "بعد الشراء، ستتلقى رابط لموقع Ooredoo الإلكتروني. يوفر الموقع بيانات ومكالمات ورسائل نصية لأكثر من 170 دولة"
    }
  },
  "travel": {
    "success_screen": {
      "header": "تم تأمينك بنجاح",
      "policy_number": "رقم التأمين:",
      "email_sent": "تم إرسال وثيقة التأمين الخاصة بك إلى بريدك الإلكتروني",
      "policy_download": "وثيقة تأمين السفر",
      "receipt_download": "وصل المعاملة",
      "qdapp_banner": {
        "header": "قم بإدارة تأمينك عبر تطبيق قطر للتأمين",
        "annotation": "يمكنك عرض تأميناتك وتنزيلها ومشاركتها أينما تريد",
        "download_button": "حمّله الآن"
      },
      "qic_domains": {
        "header": "عناوين البريد الإلكتروني التي نستخدمها للتواصل معك:",
        "annotation": "qic.online، أو qic.com.qa، أو qicgroup.com.qa"
      },
      "cyber_policy_download": "وثيقة التغطية السيبرانية",
      "airalo": {
        "header": "خصم 20%",
        "desc": "على باقات الجوّال خارج البلاد",
        "list": {
          "title": "كيفية استخدام الخصم",
          "element_1": "انتقل إلى موقع الويب الترويجي - الخصم متاح هناك فقط",
          "element_2": "اختر الوجهة وباقة الجوّال",
          "element_3": "سيتم تطبيق الخصم تلقائيًا"
        },
        "button": {
          "text": "استخدم الخصم"
        }
      },
      "ooredoo": {
        "header": "باقات جوال للمسافرين",
        "desc": "تقدم شركة Ooredoo باقات أسبوعية وشهرية تشمل البيانات والمكالمات والرسائل النصية في أكثر من 170 دولة",
        "button": "عرض الباقات"
      },
      "travel_kit": {
        "title": "إكسسوارات سفرك"
      },
      "home_insurance": {
        "title": "خصم 25% على تأمين المنزل",
        "badge": "صالح لمدة 48 ساعة",
        "description": "نحمي منزلك أثناء سفرك",
        "feature_1": "يغطي أي أضرار تلحق بالجدران والسقف والهيكل",
        "feature_2": "يغطي الأثاث والأغراض الثمينة الأخرى",
        "feature_3": "يحمي الأغراض التي تحملها أثناء السفر",
        "button": "استخدم الخصم"
      }
    },
    "outbound": {
      "select_plan": {
        "from_title": "من",
        "select_button": "اختر",
        "back_to_plans": "العودة إلى الخطط",
        "whats_covered_button": "تفاصيل التأمين",
        "continue_button": "متابعة"
      },
      "quote": {
        "insurance_period": {
          "name": "مدة التأمين"
        },
        "destination": {
          "name": "الوجهة"
        }
      },
      "covid": {
        "price_desc": {
          "text": "السعر إلى {count} أفراد"
        }
      },
      "cyber_security_addon": {
        "price_desc": {
          "text": "إلى {firstName} {secondName} فقط"
        }
      },
      "winter_sport": {
        "price_desc": {
          "text": "إلى"
        }
      },
      "popular_destinations": {
        "gcc": "دول الخليج",
        "worldwide": "جميع أنحاء العالم",
        "schengen": "دول شنغن",
        "georgia": "جورجيا"
      }
    },
    "inbound": {
      "quote": {
        "country": {
          "name": "بلد الإقامة"
        },
        "plan": {
          "name": "تأمين السفر للقادمين"
        }
      }
    },
    "common": {
      "failed": {
        "heading": "فشل في التحميل",
        "text": "يرجى إعادة المحاولة أو التواصل معنا لمساعدتك"
      },
      "quote": {
        "insured_traveler": {
          "name": "المسافر المؤمن عليه"
        },
        "inclusive_cover": {
          "name": "التغطية المشمولة"
        }
      },
      "edit": {
        "button": "تعديل"
      },
      "quote_price_desc": {
        "name": "السعر إلى {count} أفراد"
      },
      "continue": {
        "button": "متابعة"
      },
      "fiil_personal_info": {
        "fill": {
          "header": "املأ المعلومات"
        }
      },
      "choose_option": {
        "error": "يرجى الاختيار"
      },
      "get_in_touch": {
        "request_callback": "طلب معاودة الاتصال",
        "or": "أو"
      },
      "back": {
        "button": "عودة"
      },
      "progress_bar": {
        "step_1": "تفاصيل السفر",
        "step_2": "معلومات الاتصال",
        "step_3": "التغطية",
        "step_4": "المعلومات الشخصية",
        "step_5": "عرض السعر"
      },
      "server_error_popup": {
        "heading": "لم نتمكن من إرسال الطلب",
        "subheading": "حاول مرة أخرى الآن أو لاحقاً"
      },
      "callback_sent_popup": {
        "heading": "تم إرسال طلب معاودة الاتصال",
        "subheading": "سنعاود الاتصال بك خلال يوم عمل واحد"
      },
      "quote_loader": {
        "text_1": "جاري تجهيز جميع مستلزمات السفر...",
        "text_2": "جاري إضافة بعض الأمور لراحتك...",
        "text_3": "استغرق الأمر وقتاً أطول قليلاً من المتوقع، لكن أوشكت حقيبة سفرك أن تجهز..."
      },
      "success": {
        "text_1": "جاري تجهيز وثيقة تأمينك...",
        "text_2": "جاري إرسال وثيقة التأمين إلى بريدك الإلكتروني..."
      }
    }
  },
  "qic_data_protected_reminder": "جميع البيانات التي نجمعها محمية وتستعمل فقط لتحسين تجربتك",
  "qic_user_contacts_acceptance": "أوافق على تلقي المعلومات والتحديثات حول المنتجات والخدمات، والعروض الترويجية، والمزايا والمكافآت الجديدة",
  "contacts": {
    "privacy_policy": {
      "annotation": "بمتابعتك فإنك توافق على",
      "link": "سياسة الخصوصية"
    }
  },
  "outbound_travel_type_single_desc_60": "تصل إلى 60 يوم",
  "contact_us_popup": {
    "heading": "نحن هنا لنساعدك",
    "whatsapp": {
      "title": "اتصل بنا عبر الواتساب",
      "button": "ابدأ محادثة واتساب"
    },
    "phone": {
      "title": "أو دعنا نتصل بك"
    },
    "send": {
      "button": "أرسل"
    },
    "informing": {
      "text": "جميع البيانات التي نجمعها محمية وتستعمل فقط لتحسين تجربتك"
    }
  },
  "qic_error_go_home": "العودة إلى الصفحة الرئيسية",
  "qic_need_help_popup_header": "نحن هنا لنساعدك",
  "qic_base_error_contact_us": "تواصل معنا في الوقت الذي يناسبك",
  "qic_cant_provide_wa": "ابدأ محادثة واتساب",
  "qic_error_hotline": "الخط الساخن",
  "qic_base_error_heder_line": "لقد وقع خطأ ما",
  "qic_base_error_message": "عذرا، لقد وقع خطأ ما. الرجاء المحاولة مرة أخرى أو الاتصال بفريق الدعم الفني إذا استمرت المشكلة",
  "qic_error_try_again": "إعادة المحاولة",
  "qic_base_error_phone_header": "نحن هنا لنساعدك",
  "qic_need_help_sent_popup_header": "لقد تلقينا طلبك",
  "qic_need_help_sent_popup_message": "سيتصل بك مسؤول الخدمة قريباً",
  "qic_quote_number": "رقم عرض السعر",
  "qic_quote_insurance_amount": "حدود التأمين",
  "checkout": {
    "payment_block": {
      "promo_code": {
        "title": "استخدم رمز ترويجي"
      },
      "your_quote": {
        "title": "عرض السعر"
      },
      "addons": {
        "title": "تغطيات إضافية",
        "title_new": "الإضافات"
      },
      "discounts": {
        "title": "الخصومات"
      },
      "total": {
        "title": "المجموع"
      },
      "select_method": {
        "title": "إختر طريقة الدفع"
      },
      "credit_card": {
        "title": "بطاقة ائتمان أو خصم"
      },
      "naps_debit": {
        "title": "بطاقة خصم قطرية"
      },
      "apple_pay": {
        "title": "Apple Pay"
      },
      "google_pay": {
        "title": "Google Pay"
      },
      "checkbox_confirmation": {
        "text": "أوافق على ",
        "link": " الشروط والأحكام"
      },
      "confirmation": {
        "text": "بمتابعتك فإنك توافق على",
        "link": "أحكام وسياسة الدفع الخاصة بنا"
      },
      "security_informing": {
        "text": "جميع المدفوعات على هذه الصفحة محمية بواسطة بروتوكول طبقة المنافذ الآمنة"
      }
    }
  },
  "qic_quote_checkout_button": "إشتر الآن",
  "qic_base_error_heder_line1": "لقد وقع",
  "qic_base_error_heder_line2": "خطأ ما",
  "qic_dropdown_save_button": "حفظ",
  "qic_have_promocode": "استخدم رمز ترويجي",
  "qic_promocode": "الرمز الترويجي",
  "qic_contact_us": "هل تحتاج مساعدة؟ اتصل بنا",
  "qic_promocode_invalid": "الرمز غير صحيح. الرجاء استعمال رمز صحيح",
  "qic_promocode_applied": "تم تفعيل الرمز الخاص بك",
  "qic_promocode_apply": "تفعيل",
  "till": "إلى",
  "qic_ok": "حسنا!",
  "travelers": {
    "add_button": "إضافة"
  },
  "payment_terms_popup": {
    "heading": "الشروط والأحكام",
    "dibsy": {
      "text": "خدمات معالجة المدفوعات لعملاء شركة قطر للتأمين مقدمة من شركة (Paywise QFC Branch (Dibsy. جميع المعلومات المقدمة هي لتعزيز تجربة العملاء ولا ترقى إلى مستوى عرض ترويجي، أو إعلان، أو دعوة، أو ترويج لأي منتج أو خدمة من Dibsy أو أي طرف ثالث. لا تحتفظ شركة قطر للتأمين، ولا تتحكم، ولا تشارك أية معلومات تتعلق باستخدامك لخدمات معالجة المدفوعات التي تقدمها شركة Dibsy. شركة قطر للتأمين غير مسؤولة ولا ولن تتحمل أي التزام، أو ضمانات، أو مسؤولية عن خدمات الدفع المقدمة من شركة Dibsy. الرجاء قراءة الشروط والأحكام والتنازلات الخاصة بموقع شركة Dibsy قبل الوصول إلى خدماتها. لا تتحمل شركة قطر للتأمين والشركات التابعة وموظفوها ومسؤولوها ومديروها ووكلاؤها أية مسؤولية من أي نوع عن أية خسارة تتكبدها في حالة حدوث أي نقص في خدمات شركة Dibsy، أو جراء فشل أو تعطيل خدمات شركة Dibsy،أو جراء أي فعل أو إغفال من قبل أي طرف آخر معني بعملية الدفع."
    },
    "qnb": {
      "text": "تتم إعادة توجيهك إلى موقع طرف ثالث بناءً على طلبك (موقع الدفع لبنك قطر الوطني) حيث يمكنك السداد من حساب مصرفي آخر. لا تضمن شركة قطر للتأمين (QIC)  صحة أو اكتمال المعلومات أو المواد أو الخدمات أو البيانات المعروضة أو الموزعة على موقع الطرف الثالث. يُسمح لك بالوصول إلى هذا الموقع لأغراض دفع قسط وثيقتك فقط، وبهذا فإنك تُقر بأن الاستفادة من أي خدمات معروضة على الموقع أو الاعتماد على أي رأي أو نصيحة أو بيان أو مذكرة أو معلومات متاحة على الموقع تكون على مسؤوليتك الخاصة. لا تتحمل شركة قطر للتأمين والشركات التابعة وموظفوها ومسؤولوها ومديروها ووكلاؤها المسؤولية عن أي نقص في الخدمات التي يقدمها بنك قطر الوطني الذي أنت على وشك الوصول إلى موقعه. لا تتحمل شركة قطر للتأمين والشركات التابعة وموظفوها ومسؤولوها ومديروها ووكلاوها أية مسؤولية من أي نوع عن أية خسارة تتكبدها في حالة حدوث أي نقص في خدمات بنك قطر الوطني، أو جراء فشل أو تعطيل موقع بنك قطر الوطني، أو جراء أي فعل أو إغفال من قبل أي طرف آخر معني بجعل هذا الموقع أو البيانات الواردة فيه متاحة لك، أو بأي سبب آخر يتعلق بوصولك للموقع، أو عدم قدرتك على الوصول للموقع، أو استخدامه."
    }
  },
  "close": {
    "button": "إغلاق"
  },
  "day_1": "الأحد",
  "day_2": "الإثنين",
  "day_3": "الثلاثاء",
  "day_4": "الأربعاء",
  "day_5": "الأربعاء",
  "day_6": "الجمعة",
  "day_7": "السبت",
  "usd": "دولار أمريكي",
  "price": "السعر:",
  "ramadan": {
    "header": {
      "text": {
        "1": "اربح سيارة",
        "2": "مع قطر للتأمين!"
      }
    },
    "popup": {
      "header": "اربح سيارة جيتور T2 وجوائز أخرى",
      "subtitle": {
        "1": "اشتر تأمين السفر",
        "2": "واحصل على",
        "3": "قسائم للدخول في السحب"
      }
    },
    "select_plan_label": {
      "outbound": "ستحصل على 4 قسائم مع فرص أكبر لربح سيارة"
    },
    "checkout": {
      "total": "عدد القسائم التي ستضاف إلى رصيدك"
    },
    "success_page": {
      "title": "لقد حصلت على قسائم",
      "subtitle": "جمع قسائم عبر تطبيق قطر للتأمين واحصل على فرصة ربح جيتور T2 وجوائز أخرى",
      "scan": "امسح الرمز لتحميل التطبيق",
      "button": {
        "go_to_store": "حمّل التطبيق الآن"
      }
    }
  },
  "addon": {
    "cyber": {
      "excess": {
        "info": "لن يتم تغطية المطالبات التي تقل عن 100 دولار أمريكي وسيتم خصم 100 دولار أمريكي من المطالبات الأعلى قيمة",
        "amount": "100 دولار أمريكي",
        "label": "الرسوم الإضافية:"
      }
    }
  },
  "cyber_security_addon": {
    "name": "التغطية السيبرانية",
    "popup": {
      "header": {
        "1": "نحن نغطيك في حال",
        "2": "ما لا يتم تغطيته"
      },
      "desc": "تغطية تصل إلى 5,000 دولار أمريكي. الرسوم الإضافية: 100 دولار أمريكي. أما المطالبات الأكبر، يتم خصم 100 دولار أمريكي من إجمالي المبلغ",
      "block": {
        "1": {
          "header": "التعرض للاحتيال أثناء التسوق عبر الإنترنت",
          "desc": "اشتريت جهازا إلكترونيا عبر الإنترنت ودفعت المبلغ مقدما، ولكن بعد أسابيع لم يصل طلبك، واكتشفت أن موقع البائع قد اختفى. مع هذه التغطية، ستحصل على الحماية من عمليات الشراء الاحتيالية وإمكانية استرداد أموالك"
        },
        "2": {
          "header": "تعرض هاتفك أو جهاز الكمبيوتر لهجوم برامج الفدية أو هجوم إلكتروني",
          "desc": "عند عودتك إلى المنزل وتشغيل جهاز الكمبيوتر، لاحظت أن جميع ملفاتك مشفرة بسبب هجوم برامج الفدية ، نتيجة تعرض جهازك لهجوم إلكتروني. ستساعدك هذه التغطية على دفع تكاليف استرجاع البيانات وتأمين جهازك"
        },
        "3": {
          "header": "سرقة أموال من حسابك البنكي",
          "desc": "تلقيت رسالة على بريدك إلكتروني تبدو وكأنها من البنك الذي تتعامل معه تطلب منك إدخال بياناتك الشخصية. بعد اتباع التعليمات، اكتشفت أنك تعرضت لعملية احتيال وتم سحب أموال من حسابك. هذه التغطية ستحميك من عمليات الاحتيال الإلكتروني والمعاملات غير المصرح بها"
        },
        "4": {
          "header": "فقدان الملفات بسبب عطل في النظام أو حادث إلكتروني",
          "desc": "جميع ملفاتك المهمة اختفت فجأة—مستندات العمل، والصور، وجهات الاتصال—بسبب عطل في النظام أو هجوم إلكتروني. مع تغطية استعادة البيانات، ستتمكن من استرجاع ملفاتك دون دفع أي تكاليف إضافية"
        },
        "5": {
          "header": "سرقة بياناتك الشخصية",
          "desc": "تقدمت بطلب للحصول على قرض، لكنك تفاجأت بوجود ديون لم تقم بأخذها، مما يعني أنه تم استخدام بياناتك الشخصية لفتح حسابات باسمك. مع تغطية الحماية من انتحال الشخصية، يمكنك استعادة سمعتك المالية."
        },
        "6": {
          "header": "التعرض للتنمر الإلكترونية",
          "desc": "تعرضت لمضايقات عبر الإنترنت أثرت على حياتك الشخصية والمهنية. تغطية التنمر الإلكتروني ستساعدك في دفع الرسوم القانونية وستقدم لك الدعم اللازم للتعامل مع هذه المضايقات"
        }
      },
      "list": {
        "1": "سرقة البطاقة نفسها",
        "2": "أي خسائر يغطيها البنك أو أي جهة أخرى",
        "3": "الأضرار المادية للأجهزة",
        "4": "فقدان الاتصال بالإنترنت"
      },
      "button": {
        "add": "أضف إلى التغطية الأساسية"
      }
    }
  },
  "bonuses": {
    "popup": {
      "description": {
        "user_not_registered": "لقد حصلت على كوينز! قم بتوفيرها وإنفاقها داخل تطبيق قطر للتأمين",
        "user_registered": "لقد حصلت على كوينز! يمكنك إنفاقها داخل تطبيقنا"
      }
    }
  },
  "common": {
    "domains_list": {
      "subtitle": "qic.online، أو qic.com.qa، أو qicgroup.com.qa",
      "title": "عناوين البريد الإلكتروني التي نستخدمها للتواصل معك:"
    },
    "go_to_app": {
      "button": "انتقل إلى التطبيق"
    },
    "whatsapp": {
      "button": "ابدأ محادثة واتساب"
    },
    "call": {
      "button": "اتصل بنا على"
    },
    "get_in_touch": "تواصل معنا",
    "availabilty_hours": "نحن في خدمتكم يومياً من 7 صباحاً حتى 8 مساءً"
  },
  "success_page": {
    "bonuses": {
      "label": {
        "see_more": "عرض المزيد"
      }
    }
  },
  "app_banner": {
    "manage_policy": {
      "desktop": {
        "subtitle": "يمكنك عرض الوثائق وتحميلها ومشاركتها أينما تريد",
        "title": "قم بإدارة تأمينك عبر تطبيق قطر للتأمين"
      },
      "mobile": {
        "subtitle": "إدارة تأميناتك",
        "title": "تطبيق قطر للتأمين"
      }
    }
  },
  "qar_price": "{price} ر.ق",
  "airalo": {
    "pop_up": {
      "header": "اشترِ تأمين السفر واحصل على خصم 20% على eSIM من Airalo",
      "block_1": {
        "header": "ما هي شريحة eSIM؟",
        "desc": "شريحة eSIM هي شريحة جوّال رقمية تتيح لك الاتصال بشبكات الجوّال المختلفة"
      },
      "block_2": {
        "header": "ماذا الذي تتضمنه الباقة؟",
        "desc": "تقدم Airalo باقات بيانات مرنة. ويشمل بعضها المكالمات والرسائل النصية"
      },
      "block_3": {
        "header": "هل وجهتي مشمولة؟",
        "desc": "تغطي Airalo أكثر من 200 دولة. يمكنك العثور على القائمة الكاملة على موقعهم الإلكتروني"
      },
      "block_4": {
        "header": "كيف احصل على الخصم؟",
        "desc": "سنزودك برابط إلى موقع الويب حيث يمكنك تطبيق الخصم"
      },
      "button": "شراء التأمين"
    }
  },
  "select_plan": {
    "coins": "ستحصل على +{value}",
    "coins_discount": "خصم الكوينز",
    "earn_coins": "اكسب {coins}",
    "price_with_coins": "أو {price} ر.ق مع الكوينز",
    "spend_coins": "أنفق {coins}"
  }
}
